import axios from "axios"
const tokens = window.tianditu?.token || []
const apiUrl = window.tianditu?.apiUrl
export default class TiandituAddressSearchServer {
  constructor(props_data) {
    const props = props_data || {}
    this.tokens_ = props['token'] || tokens
    this.url_ = props['apiUrl'] ||apiUrl
    this.searchUrl_ = this.url_ + '/v2/search'
    this.geocodeUrl_ = this.url_ + '/geocoder'
  }

  query(queryProps) {
    const postStr = { ...queryProps }
    postStr.yingjiType = 0
    postStr.queryType = "1"
    const params = this._getParams(postStr)
    return new Promise((resolve, reject) => {
      axios.get(this.searchUrl_, { params }).then(res => {
        const list = []
        if (res.data.pois) {
          res.data.pois.forEach(item => {
            try {
              const lonlat = item.lonlat.split(",")
              const coordinates = [Number(lonlat[0]), Number(lonlat[1])]
              list.push({
                ...item,
                point:coordinates
              })
            } catch (error) {}
          })
          resolve({list,count:res.data.count})
        }else if(res.data.area){
          const bound = res.data.area.bound
          const coords = bound ? bound.split(","):[]
          resolve({extent:coords})
        }
        
      }).catch(err => { reject(err)})
    })
  }

  suggests(queryProps) {
    const postStr = {...queryProps}
    postStr.yingjiType = 1
    postStr.queryType = "4"
    const params = this._getParams(postStr)
    return new Promise((resolve, reject) => {
      if (params && postStr.keyWord) {
        axios.get(this.searchUrl_, { params }).then(res => {
          const suggests = res.data?.suggests || []
          resolve(suggests)
        }).catch(err => {
          reject(err)
        })
      }else{
        resolve([])
      }
    })
  }

  geocode(pt){
    const params={
      postStr:JSON.stringify({
        lon:pt[0],
        lat:pt[1],
        ver:1
      }),
      type: 'geocode',
      tk: this._getToken()
    }
    return new Promise((resolve, reject) => {
      axios.get(this.geocodeUrl_, { params }).then(res => {
        resolve(res.data?.result?.formatted_address || '')
      })
    })
  }

  _getParams(postObj) {
    const token = this._getToken()
    if (!token) {
      return
    }
    const postStr = this._buildPostStr(postObj)
    return {
      postStr:postStr,
      type: 'query',
      tk: token
    }
  }

  _buildPostStr(postObj) {
    if (postObj.start===undefined) {
      postObj.start = 0
    }
    if (!postObj.count) {
      postObj.count = 10
    }
    if (postObj.sourceType===undefined) {
      postObj.sourceType = 0
    }
    if (postObj.yingjiType===undefined) {
      postObj.yingjiType = 1
    }
    if (!postObj.queryType) {
      postObj.queryType = "4"
    }
    if (!postObj.level) {
      postObj.level = 3
    }
    if(!postObj.mapBound) {
      postObj.mapBound = "55.247070312500654,-8.436804404647532,155.0029296875009,55.75971961193923"
    }
    if (!postObj.queryTerminal) {
      postObj.queryTerminal = 10000
    }

    return JSON.stringify(postObj) 
  }

  _getToken() {
    return this.tokens_.length > 0 ? this.tokens_[Math.floor(Math.random() * this.tokens_.length)] : ''
  }
}
